import { useSubscription } from "@/contexts/SubscriptionContext";

/**
 * Returns whether a premium feature is accessible.
 * Rules:
 *  - trial active → allowed
 *  - enterprise plan (€189) → allowed
 *  - active marketplace addon → allowed
 *  - otherwise → blocked
 */
export function useFeatureGate(featureKey) {
  const { status, plan, trialDaysLeft, hasModuleAccess, loading } = useSubscription();

  // Fail open while subscription data loads — avoids flash of locked state for allowed users.
  // Blocked users will see content for ~1s then the locked screen appears; acceptable tradeoff.
  if (loading) return "allowed";

  // Trial: allowed if still on trial (null = no expiry set → still valid)
  if (status === "trial" && (trialDaysLeft === null || trialDaysLeft > 0)) return "allowed";

  // Enterprise plan (€189) includes all premium features
  if (plan === "enterprise") return "allowed";

  // Check active marketplace addon subscription
  return hasModuleAccess(featureKey) ? "allowed" : "blocked";
}
